import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { UitkInput } from './uitk-input.esm.js';
var UitkCardNumberInput = function (props) {
  var children = props.children,
    remaining = __rest(props, ["children"]);
  return React.createElement(UitkInput, __assign({}, remaining, {
    type: "text"
  }), React.createElement("span", {
    className: "uitk-card-number-input-payment-type"
  }, children));
};
UitkCardNumberInput.displayName = 'UitkCardNumberInput';
export { UitkCardNumberInput };